// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__I9dZi","item":"Chart_item__-+dmj","text":"Chart_text__EEODU"};